export default {
    navigationBarTitleText: '代画退款',
};
